import { CheckCircle2, CircleOff } from 'lucide-react';
import { Panel } from '@/components/dashboard/Panel';
import type { Endpoint } from '@/types/endpoint';

interface TraefikPanelProps {
  endpoint: Endpoint;
}

/** Traefik is deployed out-of-band; the sync worker detects the `traefik-router` stack. */
export function TraefikPanel({ endpoint }: TraefikPanelProps) {
  const deployed = endpoint.traefik_deployed;

  return (
    <Panel title="Reverse proxy" loading={false} error={null} hasData>
      <div className="space-y-3">
        <p className="flex items-start gap-1.5 text-sm">
          {deployed ? (
            <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-status-success" aria-hidden />
          ) : (
            <CircleOff className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden />
          )}
          <span>
            <span className="font-medium">Traefik: </span>
            {deployed ? `Running (stack #${endpoint.traefik_stack_id})` : 'Not deployed'}
          </span>
        </p>
        {!deployed ? (
          <p className="text-sm text-muted-foreground">
            Traefik isn't deployed from here in this version. Deploy a Portainer stack named <code>traefik-router</code> on
            this endpoint — it is detected on the next sync. Apps that need a subdomain can't be deployed here until then.
          </p>
        ) : null}
      </div>
    </Panel>
  );
}
